module.exports = __webpack_public_path__ + "static/img/nav_bg.8b2d6f4d.png";